/**
 * The production host string for the investment subdomain.
 */
const investmentProd = 'investment.agreserves.com';
/**
 * Determines whether the app is running in a production deployment by comparing window.location.host against VITE_PROD_ENV and the investment subdomain.
 */
export const isProd = window.location.host === import.meta.env.VITE_PROD_ENV || window.location.host === investmentProd;
// export const isProd = window.location.host === import.meta.env.VITE_PROD_ENV || window.location.host === import.meta.env.VITE_PROD_ENV_INVESTMENT;

/**
 * The base ENV path for AIM API calls, combining VITE_INFOR_ENV with '/aim'.
 */
export const ENV = `${import.meta.env.VITE_INFOR_ENV}/aim`;

// export const INFOR_ENV = !isProd
//   ? `${import.meta.env.VITE_INFOR_ENV}`
//   : `${import.meta.env.VITE_INFOR_ENV_PROD}`;

/**
 * The INFOR environment string pulled from the VITE_INFOR_ENV env variable.
 */
export const INFOR_ENV = `${import.meta.env.VITE_INFOR_ENV}`;

/**
 * The base service URL string for AIM API calls, pulled directly from the VITE_AIM_SERVICE environment variable.
 */
export const AIM_SERVICE = import.meta.env.VITE_AIM_SERVICE;